<script>
import VCardEvents from "@/components/Events/VCardEvents.vue";
import VCardForums from "@/components/Events/VCardForums.vue";
import DictionariesSync from "@/components/Dictionaries/DictionariesSync.vue";
import VCardActivity from "@/components/Events/VCardActivity.vue";
import VCardAttention from "@/components/Events/VCardAttention.vue";

export default {
    name: "Forums",
    components: {
        VCardAttention,
        VCardActivity,
        DictionariesSync,
        VCardForums,
        VCardEvents,
    },
    methods: {},
}
</script>

<template>
    <v-container fluid class="down-top-padding">
        <v-row :no-gutters="false" align="stretch">
            <v-col cols="12" sm="6" class="pa-0">
                <!--
                <v-container class="fill-height pa-0">
                    <v-row class="flex-column fill-height">
                        <v-col class="flex-grow-0 pt-0">
                            <v-card elevation="2" class="pa-3"> Row 1</v-card>
                        </v-col>
                        <v-col class="flex-grow-1">
                            <v-card elevation="2" class="pa-3 fill-height"> Row 2</v-card>
                        </v-col>
                        <v-col class="flex-grow-0 pb-0">
                            <v-card elevation="2" class="pa-3"> Row 3</v-card>
                        </v-col>
                    </v-row>
                </v-container>
                -->
                <div class="d-flex flex-nowrap flex-column fill-height">
                    <v-col class="flex-grow-0 hide-empty">
                        <v-card-attention></v-card-attention>
                    </v-col>
                    <v-col class="flex-grow-1">
                        <v-card-events
                            :url="$apiUrl.getWidgetEventsNearby()"
                            heading="Актуальные мероприятия"
                            class="fill-height"
                        ></v-card-events>
                    </v-col>
                </div>
            </v-col>
            <v-col cols="12"
                   sm="6">
                <v-card-activity></v-card-activity>
            </v-col>
        </v-row>
        <!--
        ...
        -->
        <v-row>
            <v-col>
                <dictionaries-sync></dictionaries-sync>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-card-forums
                    :url="$apiUrl.getForumsUrl()"
                    heading="Форумы"
                ></v-card-forums>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card-events
                    :url="$apiUrl.getForumEventsUrl({ID_FORUM: 0})"
                    heading="Мероприятия без форума"
                ></v-card-events>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped lang="scss">
.hide-empty:empty {
    display: none;
}
</style>
